<template>
  <section>
    <h5>Payment No. {{ payment.id }}</h5>
    <b-row>
      <b-col>
        <table style="width: 100%">
          <tr>
            <th>Customer</th>
            <th>Date</th>
            <th>Method</th>
            <th>Account</th>
            <th>Reference</th>
            <th>Amount</th>
          </tr>
          <tr>
            <td>{{ payment.companyName}}</td>
            <td>{{ date(payment.paymentDate) }}</td>
            <td>{{ payment.paymentMethodName }}</td>
            <td>{{ payment.depositToName }}</td>
            <td>{{ payment.referenceNumber }}</td>
            <td>{{ commafy(payment.amount, '$', 2 ) }}</td>
          </tr>
        </table>
      </b-col>  
    </b-row>
    <hr/>
    <h5>Expenses</h5>
    <b-row>
      <b-col>
        <table style="width: 100%">
          <tr>
            <th>Type</th>
            <th>Date</th>
            <th>Amount</th>
          </tr>
          <tr v-for="(expense, ndx) in payment.expenses" :key="ndx">
            <td>{{expense.expenseAccountName}}</td>
            <td>{{date(expense.expenseDate)}}</td>
            <td>{{ commafy(expense.amount, '$', 2 ) }}</td>
          </tr>
        </table>
      </b-col>
    </b-row>
    <hr/>
    <h5>Credits Applied</h5>
    <b-row>
      <b-col>
        <table style="width: 100%">
          <tr>
            <th>Credit Date</th>
            <th>Amount</th>
            <th>Balance</th>
            <th>Payment</th>
          </tr>
          <tr v-for="(tran, ndx) in payment.creditMemoTransactions" :key="ndx">
            <td>{{ date(tran.creditDate) }}</td>
            <td>{{commafy(tran.creditAmount, '$', 2)}}</td>
            <td>{{commafy(tran.balance, '$', 2)}}</td>
            <td>{{commafy(tran.amount, '$', 2)}}</td>
          </tr>
        </table>  
      </b-col>
    </b-row>
    <hr/>
    <h5>Invoices</h5>
    <b-row>
      <b-col>
        <table style="width:100%">
          <tr>
            <th>#</th>
            <!-- <th>Date</th> -->
            <th>Balance</th>
            <th>Payment</th>
            <th>Credit</th>
            <th>Amount</th>
          </tr>
          <tr v-for="(invoice, ndx) in payment.lines" :key="ndx">
            <td>{{invoice.invoiceId}}</td>
            <td>{{ commafy(invoice.balance, '$', 2 ) }}</td>
            <td>{{ commafy(invoice.paymentAmount, '$', 2 )}}</td>
            <td>{{ commafy(invoice.creditAmount, '$', 2 )}}</td>
            <td>{{ commafy(invoice.amount, '$', 2 )}}</td>
            <!-- <td>data</td> -->
          </tr>
        </table>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {mapGetters} from 'vuex';
import { date } from '@/shared/filters';

export default {
  props: {
    payment: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      date,
    }
  },
  computed: {
    ...mapGetters('receivePayments', {payment: 'receivePayment'})
  },
  methods: {
    commafy(num, currency = "", decimal = 2) {
      try {
        if (num != null) {
          if (currency != "") {
            num = Number(num).toFixed(decimal);
          }
          var str = num.toString().split('.');
          if (str[0].length >= 3) {
            str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
          }
          if (str[1]) {
            if (str[1].length < decimal) {
              while (str[1].length < decimal) { str[1] = str[1] + "0"; }
            } else if (str[1].length > decimal) {
              str[1] = str[1].substring(0, decimal)
            }
          }
          return currency + str.join('.');
        }
      } catch {
        return num;
      }
    },
  }

}
</script>